import React from 'react'
import classNames from 'classnames'
import ConversationStarter from '#src/components/ConversationStarter'
import { withIdentity, WithIdentityProps } from '#src/containers/Identity'
import { ChatWidget, withChat, WithChatProps } from '@deal/chat-firebase'
import { ChatWidgetExpertFragment } from '#src/generated/graphql'
import { withRouter, RouteComponentProps } from 'react-router'
import { Experiment } from '@deal/experiment-js'
import { isExpertPresent } from '#src/services/presence'
import styles from './styles.css'
import useBreakpoint from '#src/hooks/useBreakpoint'

interface ChatHeadProps {
  onStartConversation: () => any
  businessUserId: string
  conversationId?: string | null
  className?: string
  collapsedClassName?: string
  expert: ChatWidgetExpertFragment
}

const ChatHeadContainer: React.SFC<WithIdentityProps &
  ChatHeadProps &
  WithChatProps &
  RouteComponentProps<{}>> = ({
  myself,
  className,
  collapsedClassName,
  conversationId,
  chatClient,
  onStartConversation,
  expert,
  history
}) => {
  if (!myself || !chatClient) {
    return null
  }

  // Hide the chat widget if the cart is expanded
  const isCartOpen = history.location.hash === '#cart'
  let zindexClass = ''
  if (isCartOpen) {
    zindexClass = styles.pushedBack
  }

  const isLargerThanMd = useBreakpoint('md')

  return (
    <Experiment id="tab-bar" default="off" options={{ suppressTracking: isLargerThanMd }}>
      {({ result: tabbarResult }) => {
        const showChatWidget = !isLargerThanMd && tabbarResult === 'off'

        if (showChatWidget) {
          return (
            <ChatWidget
              userId={expert.messagingUser.id}
              conversationId={conversationId || undefined}
              online={isExpertPresent(expert)}
              rating={'stars'}
              history={history}
              getAppRoot={() => document.querySelector('#deal')}
              collapsedClassName={collapsedClassName}
              className={classNames(className, zindexClass)}
              onConversationStarted={() => {
                onStartConversation()
              }}
            >
              <ConversationStarter expert={expert} />
            </ChatWidget>
          )
        } else {
          return null
        }
      }}
    </Experiment>
  )
}

export default withRouter(withIdentity(withChat(ChatHeadContainer)))
